import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/80'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[68px] items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => setMenuOpen(false)}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-closed-captioning-line text-lg"></i>
          </span>
          <span className="font-heading text-base md:text-lg font-bold text-foreground-950 whitespace-nowrap">
            中文在线字幕
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#entry"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 dark:text-foreground-950 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            查看官方入口
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200/80 bg-background-50 px-4 py-3">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-secondary-100 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#entry"
              onClick={() => setMenuOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50 dark:text-foreground-950 cursor-pointer"
            >
              查看官方入口
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}